'use client';

import { c as _c } from "react/compiler-runtime";
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import instantPlayDevices from '@/public/images/viverse-plus/instant-play-devices.webp';
export default function InstantPlaySection() {
  const $ = _c(40);
  const t = useTranslations();
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      opacity: 0,
      y: 16
    };
    t1 = {
      opacity: 1,
      y: 0
    };
    t2 = {
      once: true,
      amount: 0.2
    };
    t3 = {
      duration: 0.6,
      ease: "easeOut"
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("plus.instant-play.eyebrow");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <p className="text-vive-primary-40 text-xs leading-4 font-extrabold tracking-[6.15px] uppercase">{t4}</p>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("plus.instant-play.title");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t) {
    t7 = t("plus.instant-play.highlight");
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <span className="mt-4 block bg-[linear-gradient(89deg,#53fff6_30%,#f3deff_44%,#ff82fb_80%)] bg-clip-text text-transparent">{t7}</span>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t6 || $[15] !== t8) {
    t9 = <h2 className="mt-4 text-3xl leading-10 font-extrabold tracking-[0.15px] text-[#eeeef0] sm:text-[38px]">{t6}{t8}</h2>;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t) {
    t10 = t("plus.instant-play.description");
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10) {
    t11 = <p className="text-vive-primary-30 mt-4 max-w-[660px] text-[15px] leading-[26px]">{t10}</p>;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t5 || $[23] !== t9) {
    t12 = <motion.div initial={t0} whileInView={t1} viewport={t2} transition={t3}>{t5}{t9}{t11}</motion.div>;
    $[21] = t11;
    $[22] = t5;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  let t14;
  let t15;
  let t16;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      opacity: 0,
      y: 24
    };
    t14 = {
      opacity: 1,
      y: 0
    };
    t15 = {
      once: true,
      amount: 0.2
    };
    t16 = {
      duration: 0.6,
      ease: "easeOut",
      delay: 0.12
    };
    $[25] = t13;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
  } else {
    t13 = $[25];
    t14 = $[26];
    t15 = $[27];
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t) {
    t17 = t("plus.instant-play.image-alt");
    $[29] = t;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      width: "100%",
      height: "auto"
    };
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t17) {
    t19 = <Image src={instantPlayDevices} alt={t17} width={1200} height={670} loading="eager" sizes="(max-width: 768px) 100vw, 1024px" className="max-w-5xl" style={t18} />;
    $[32] = t17;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="absolute inset-0 bg-linear-to-b from-[rgba(18,18,22,0.3)] to-[#121216]" />;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t19) {
    t21 = <motion.div className="mt-24 w-full max-w-5xl" initial={t13} whileInView={t14} viewport={t15} transition={t16}><div className="relative max-w-5xl">{t19}{t20}</div></motion.div>;
    $[35] = t19;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== t12 || $[38] !== t21) {
    t22 = <div className="overflow-hidden px-6 pt-16 pb-20 text-center sm:px-12 sm:pt-20 sm:pb-28 lg:pt-[52px] lg:pb-0"><div className="mx-auto flex max-w-[1200px] flex-col items-center">{t12}{t21}</div></div>;
    $[37] = t12;
    $[38] = t21;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  return t22;
}